<template>
	<div v-if="touch" class="key" :class="['key-' + touch.letter, touch.pressed || !touch.active ? 'pressed' : '', is_vowel ? 'vowel' : '', is_highlight ? 'highlight' : '']">
		<!-- <span v-if="touch.points" class="points">{{ touch.points }}</span> -->
	
		<span class="letter">
			<span>{{ touch.letter }}</span>
		</span>
	
	</div>
</template>

<script>

export default {
	name: 'Key',
	data () {
		return {

		}
	},
	props: {
		touch: false
	},
	computed: {
		is_vowel: function() {
			return (this.touch.letter == 'E' || this.touch.letter == 'A' || this.touch.letter == 'I' || this.touch.letter == 'O' || this.touch.letter == 'U' || this.touch.letter == 'Y')
		},
		is_highlight: function() {
			if (this.touch.highlight) return true
			return false
		}
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.key
	height 100%
	width 100%
	background #fff
	border-radius 20px
	box-shadow inset 0 -6px 0 0 alpha(dark, 25%)
	text-align center
	text-transform uppercase
	font-family 'Inconsolata'
	color #333
	// transition 0.05s 
	&.vowel
		background-color lightblue
	&.highlight
		background-color lightyellow
	&.pressed
		transform translate3D(0, 5px, 0)
		background-color #999
		color #777
		&.vowel
			background-color darken(desaturate(lightblue, 85%), 25%)
		&.highlight
			background-color darken(desaturate(lightyellow, 85%), 25%)
		.points
			display none
	.points
		// display none
		position absolute
		top 5px
		right 12px
		color alpha(#000, 20%)
		font-size 12px
		letter-spacing -2px
	.letter
		line-height (64px - 6px)
		font-size 26px
	.icon
		position absolute
		left 50%
		top calc(50% - 4px)
		transform translate3D(-50%, -50%, 0)

</style>



// WEBPACK FOOTER //
// src/components/ui/Key.vue